// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vert-autocomplete-box {
  position: absolute;
  top: 48px;
  background: #fff;
  width: 100%;
  border-color: transparent !important;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 20, 0.12);
  padding: var(--spacing-small);
  border-radius: 0px 0px 8px 8px;
  box-sizing: border-box;
  max-height: 388px;
  z-index: 2;
  overflow: auto;
}
.vert-autocomplete-box::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.vert-autocomplete-box::-webkit-scrollbar-thumb {
  background-color: #D9D9D9 !important;
}
.vert-autocomplete-box .history-title.vert-paragraph.ant-typography {
  color: var(--color-neutral-dark-lighter);
  font-family: var(--font-family);
  font-size: var(--font-small);
  font-weight: 500;
  line-height: var(--font-paragraph-line);
  text-decoration: none;
  padding-bottom: var(--spacing-small);
}
.vert-autocomplete-box .history-items a,
.vert-autocomplete-box .result-items a {
  color: var(--color-neutral-dark);
  font-family: var(--font-family);
  font-size: var(--font-paragraph);
  font-weight: 500;
  line-height: 18px;
  text-decoration: none;
}
.vert-autocomplete-box .history-items .txt-history-icon,
.vert-autocomplete-box .result-items .txt-history-icon,
.vert-autocomplete-box .history-items .txt-result-icon,
.vert-autocomplete-box .result-items .txt-result-icon {
  color: var(--color-border);
}
.vert-autocomplete-box .history-items li:hover a,
.vert-autocomplete-box .result-items li:hover a {
  color: var(--color-detached) !important;
}
.vert-autocomplete-box .history-items li + li,
.vert-autocomplete-box .result-items li + li {
  margin-top: var(--spacing-small);
}
.vert-autocomplete-box .history-items + .result-items {
  padding-top: var(--spacing-small);
  margin-top: var(--spacing-small);
  border-top: var(--border-width) solid var(--color-border);
}
.vert-autocomplete-box .history-items + .result-items .color-detached {
  color: var(--color-detached) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Search/autocomplete.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;EACA,gDAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;AACJ;AACI;EACI,UAAA;EACA,WAAA;AACR;AACI;EACI,oCAAA;AACR;AAIY;EACI,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,gBAAA;EACA,uCAAA;EACA,qBAAA;EACA,oCAAA;AAFhB;AA7BA;;EAsCY,gCAAA;EACA,+BAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AALZ;AAtCA;;;;EA8CY,0BAAA;AAFZ;AAKY;;EAEQ,uCAAA;AAHpB;AAhDA;;EAwDY,gCAAA;AAJZ;AAQQ;EACI,iCAAA;EACA,gCAAA;EACA,yDAAA;AANZ;AAGQ;EAMQ,uCAAA;AANhB","sourcesContent":[".vert-autocomplete-box{\n    position: absolute;\n    top: 48px;\n    background: #fff;\n    width: 100%;\n    border-color: transparent !important;\n    box-shadow: 0px 1px 4px 0px rgba(0, 0, 20, 0.12);\n    padding: var(--spacing-small);\n    border-radius: 0px 0px 8px 8px;\n    box-sizing: border-box;\n    max-height: 388px;\n    z-index: 2;\n    overflow: auto;\n\n    &::-webkit-scrollbar {\n        width: 4px;\n        height: 4px;\n    }\n    &::-webkit-scrollbar-thumb {\n        background-color: #D9D9D9 !important;\n    }\n\n    .history-title {\n        &.vert-paragraph {\n            &.ant-typography {\n                color: var(--color-neutral-dark-lighter);\n                font-family: var(--font-family);\n                font-size: var(--font-small);\n                font-weight: 500;\n                line-height: var(--font-paragraph-line);\n                text-decoration: none;\n                padding-bottom: var(--spacing-small);\n            }\n        }\n    }\n\n    .history-items, .result-items {\n        a {\n            color: var(--color-neutral-dark);\n            font-family: var(--font-family);\n            font-size: var(--font-paragraph);\n            font-weight: 500;\n            line-height: 18px;\n            text-decoration: none;\n        }\n        .txt-history-icon, .txt-result-icon {\n            color: var(--color-border);\n        }\n        li {\n            &:hover {\n                a {\n                    color: var(--color-detached) !important;\n                }\n            }\n        }\n        li + li {\n            margin-top: var(--spacing-small);\n        }\n    }\n    .history-items {\n        & + .result-items {\n            padding-top: var(--spacing-small);\n            margin-top: var(--spacing-small);\n            border-top: var(--border-width) solid var(--color-border);\n\n            .color-detached{ \n                color: var(--color-detached) !important;\n            }\n        }\n    }\n    \n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
